import { render, staticRenderFns } from "./CvList.vue?vue&type=template&id=73d0d888&scoped=true&"
import script from "./CvList.vue?vue&type=script&lang=js&"
export * from "./CvList.vue?vue&type=script&lang=js&"
import style0 from "./CvList.vue?vue&type=style&index=0&id=73d0d888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d0d888",
  null
  
)

export default component.exports